import { Link } from "react-router-dom";
import SocialIcons from "./SocialIcons";
import Newsletter from "./Newsletter";
import { CATEGORIES } from "../lib/categories";

const linkClass = "text-[#f8f4ec]/75 hover:text-[#c9a45c] transition-colors";

export default function Footer() {
  return (
    <footer
      className="band-ink border-t border-[#f8f4ec]/10"
      data-testid="site-footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2" data-testid="footer-brand-column">
          <p className="text-sm max-w-sm text-[#f8f4ec]/70 leading-relaxed">
            A quiet journal about leaves, water, and the rituals in between.
            Written by tea-drinkers for tea-drinkers, since twenty twenty-six.
          </p>
          <Newsletter compact />
          <div className="mt-6">
            <SocialIcons
              size="md"
              showHandles
              linkClassName="text-[#f8f4ec]/80 hover:text-[#c9a45c]"
            />
          </div>
        </div>
        <div>
          <p className="overline overline-gold mb-4">Explore</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/blog" className={linkClass}>Journal</Link></li>
            <li><Link to="/glossary" className={linkClass}>Glossary</Link></li>
            {CATEGORIES.map((c) => (
              <li key={c.slug}><Link to={`/category/${c.slug}`} className={linkClass}>{c.name}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="overline overline-gold mb-4">The Kettle</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className={linkClass}>About us</Link></li>
            <li><Link to="/privacy" className={linkClass} data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/terms" className={linkClass} data-testid="footer-terms-link">Terms of Use</Link></li>
            <li>
              <a href="/api/rss.xml" className={linkClass} data-testid="footer-rss-link">
                RSS feed
              </a>
            </li>
            <li><Link to="/admin/login" className={linkClass}>Editor login</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#f8f4ec]/10 py-6 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#f8f4ec]/50 font-mono tracking-widest uppercase">
          <span>© 2026 The Tea List · Melbourne, Australia</span>
          <span>Brewed slowly, in no particular hurry.</span>
        </div>
      </div>
    </footer>
  );
}
